import type { IconType } from "react-icons";
import {
  FaBed,
  FaGraduationCap,
  FaHammer,
  FaHandsHelping,
  FaHeartbeat,
  FaPaw,
  FaTint,
} from "react-icons/fa";
import type { ProgramSlug } from "@/content/assets";

export const programIcons: Record<ProgramSlug, IconType> = {
  healthcare: FaHeartbeat,
  education: FaGraduationCap,
  goshala: FaPaw,
  "blood-donation": FaTint,
  "blanket-destitution": FaBed,
  "skill-development": FaHammer,
};

export function getProgramIcon(slug: string): IconType {
  return programIcons[slug as ProgramSlug] ?? FaHandsHelping;
}

const programIconColors: Record<ProgramSlug, string> = {
  healthcare: "bg-blue-500",
  education: "bg-emerald-600",
  goshala: "bg-amber-600",
  "blood-donation": "bg-red-500",
  "blanket-destitution": "bg-indigo-500",
  "skill-development": "bg-teal-600",
};

export function getProgramIconColor(slug: string): string {
  return programIconColors[slug as ProgramSlug] ?? "bg-[var(--programs-green)]";
}
